export default __webpack_public_path__ + "static/media/02_affrescati_hero_1920x1080.b6c789c6.mp4";